<template>
    <v-app-bar app class="main-app-bar topbar" height="56px" elevation="0">
        <div class="topbar-shell">
            <div class="topbar-left">
                <Logo />
                <HeaderBreadcrumbs v-if="!$auth.loading && $auth.isAuthenticated && !isProjectsLoading" />
                <div class="topbar-holiday-bg" aria-hidden="true">
                    <HolidayBanner />
                </div>
            </div>
            <div class="topbar-actions">
                <Loading
                    v-if="!$auth.loading && $auth.isAuthenticated && !isProjectsLoading"
                    :key="isProjectPath ? ($route.params.id || 'project') : 'projects'"
                    :isProjectPath="isProjectPath"
                />
                <ChatButton />
                <MarketplaceNavButton />
                <UserMenu></UserMenu>
                <v-btn
                    v-if="!$auth.loading && !$auth.isAuthenticated"
                    class="header-btn header-btn--secondary"
                    elevation="0"
                    text
                    aria-label="Войти"
                    @click="$emit('login')"
                >
                    <v-icon
                        v-if="$vuetify.breakpoint.width < 980"
                        size="20"
                        color="white"
                    >
                        mdi-login-variant
                    </v-icon>
                    <template v-else>Войти</template>
                </v-btn>
            </div>
        </div>
    </v-app-bar>
</template>

<script>
import Loading from '@/components/project/Loading'
import Logo from '@/components/Logo.vue'
import UserMenu from '@/components/userMenu/UserMenu.vue'
import ChatButton from '@/components/ChatButton.vue'
import MarketplaceNavButton from '@/components/MarketplaceNavButton.vue'
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue'
import HolidayBanner from '@/components/HolidayBanner.vue'

export default {
    name: 'AppTopbar',
    components: {
        Loading,
        Logo,
        UserMenu,
        ChatButton,
        MarketplaceNavButton,
        HeaderBreadcrumbs,
        HolidayBanner,
    },
    props: {
        isProjectsLoading: {
            type: Boolean,
            default: false,
        },
        isProjectPath: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped lang="sass">
.topbar-left
    position: relative
    isolation: isolate

.topbar-left > *:not(.topbar-holiday-bg)
    position: relative
    z-index: 2

.topbar-holiday-bg
    position: absolute
    width: min(486px, 42vw)
    height: 56px
    right: 0
    top: 50%
    transform: translateY(-50%)
    z-index: 1
    overflow: hidden
    pointer-events: none
    opacity: .55

    ::v-deep .row
        margin: 0

    ::v-deep img
        display: block
        width: 486px !important
        height: 56px
        object-fit: cover
        -webkit-mask-image: linear-gradient(to left, #000 72%, transparent 100%)
        mask-image: linear-gradient(to left, #000 72%, transparent 100%)

@media (max-width: 1280px)
    .topbar-holiday-bg
        width: min(380px, 34vw)
        opacity: .38
        ::v-deep img
            width: 380px !important

@media (max-width: 1060px)
    .topbar-holiday-bg
        display: none
</style>
